import script from "./TypeSwitchComp.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeSwitchComp.vue?vue&type=script&setup=true&lang=js"

import "./TypeSwitchComp.vue?vue&type=style&index=0&id=ffca3c12&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffca3c12"]])

export default __exports__